import * as React from "react";

export const Headings = ({ text = "", type = "h1", classes = "", link, linkClasses }) => {
  const CustomTag = type as keyof JSX.IntrinsicElements;

  if (link) {
    return (
      <CustomTag className={`text__heading ${classes}`}>
        <a href={link} className={linkClasses}>
          {text}
        </a>
      </CustomTag>
    );
  }

  return <CustomTag className={`text__heading ${classes}`}>{text}</CustomTag>;
};
